import { COUNTRY_LIST } from "../../utils";

const ViewSpeciality = ({ data }) => {
    const { specialtyId, specialtyName, abbvieProGroupSpecialtyByGroupId, createdAt } = data;

    const { country, groupSpecialtyName } = abbvieProGroupSpecialtyByGroupId;
    return (
        <div className="tab-pane__content">
            <h5 className="tab-pane__title"> Information</h5>
            <div className="info-table">
                <div className="row">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-4">Specialty ID</div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{specialtyId}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-4">Group Specialty Name</div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{groupSpecialtyName}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-4">Specialty Name</div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{specialtyName}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-4">Country</div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{COUNTRY_LIST[country]}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-4">Created At</div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{new Date(createdAt).toUTCString()}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewSpeciality;
